import axios from "axios";
import qs from "qs";
import moment from "moment";
import adcodes from "./adcode";

// 从cookie中拿到对应的值
export function getCookie(cookie, name) {
  if (!cookie) {
    return "";
  }
  let cookies = cookie.split(";");
  let cookieObj = {};
  cookies.map((obj) => {
    let objArr = obj.trim().split("=");
    cookieObj[objArr[0]] = objArr[1];
  });
  if (name) {
    return cookieObj[name];
  }
  return cookieObj;
}
//设置cookie
export function setCookie(cname, cvalue, expires) {
  var expires = "expires=" + expires;
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

// 下载文件
export function downloadFile(url, datas, fileNameStr) {
  let request = axios.create({
    responseType: "arraybuffer",
    paramsSerializer(params) {
      return qs.stringify(params, {
        encode: true,
      });
    },
  });

  request({
    method: "get",
    url: url,
    params: datas,
    headers: {
      Authorization: "Bearer " + getCookie(document.cookie, "access_token"),
    },
  })
    .then((res) => {
      let fileName = fileNameStr + ".csv" || "下载文件.csv";
      let blob = new Blob([res.data], {
        type: "text/csv;charset=utf-8",
      });
      let downloadElement = document.createElement("a");
      // 创建下载的链接
      let href = URL.createObjectURL(blob);
      downloadElement.href = href;

      fileName = decodeURI(fileName);
      // 下载后文件名
      downloadElement.download = fileName;
      document.body.appendChild(downloadElement);
      // 点击下载
      downloadElement.click();
      // 下载完成移除元素
      document.body.removeChild(downloadElement);
      // 释放掉blob对象
      URL.revokeObjectURL(href);
    })
    .catch((error) => {
      console.log(error);
    });
}

export function formatDate(date) {
  return moment(date).format("YYYY-MM-DD");
}
export function formatTime(date) {
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
}

export function adcodetoName(adcode) {
  let arr = adcodes.filter((item) => item.adcode === adcode);
  return arr.length > 0 ? arr[0]["name"] : "--";
}
export function deviceformatName(val) {
  switch (val) {
    case "Phenologic":
      return "物候监测";
    case "Atmosphere":
      return "气象监测";
    case "Insect":
      return "虫情监测";
    case "AnimalCamera":
      return "动物识别";
    case "InsectSeduce":
      return "害虫性诱";
  }
}

// export function getAttachDeviceTypeList() {
//     http({
//       method: "get",
//       url: apis.device.attachDeviceTypes,
//       params: {},
//     })
//       .then((res) => {
//         this.attachDeviceTypeList = (res.value || []).map((item) => ({
//           // label: deviceformatName(item.name),
//           label: item.description,
//           value: item.id,
//         }));
//       })
//       .catch((error) => {
//       });
//   },
